import { useMutation } from '@apollo/client';
import { DELETE_PICKUP_ROUTE } from '../graphql/mutations/deletePickupRoute';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';

export const useDeletePickupRoute = () => {
  const { t } = useTranslation();
  const [deletePickupRoute, { loading, error }] = useMutation(DELETE_PICKUP_ROUTE);

  const deleteRoute = async (id: number) => {
    try {
      const response = await deletePickupRoute({
        variables: { id },
      });
      
      if (response.data?.deletePickupRoute) {
        return true;
      } else {
        throw new Error(t('pickup.pickupTask.pageDetails.messages.failedToDeleteRoute') || '');
      }
    } catch (err: any) {
      console.error('Error deleting pickup route:', err);
      const errorMessage = err.message || t('pickup.pickupTask.pageDetails.messages.failedToDeleteRoute') || '';
      message.error(errorMessage);
      throw err;
    }
  };

  return {
    deleteRoute,
    loading,
    error,
  };
};
